import React from 'react';
import Loader from 'react-loader-spinner';
import '../theme/styles/AddovationGreenThemeStyle';
import { useTheme } from '../theme/OAS365Theme';

function App() {
  const currentTheme = useTheme();
  return (
    <Loader
      type="ThreeDots" 
      height={40}
      width={40} 
      color={currentTheme.colors.themeDarkColor}
    />
  );
}

export default App;


